import { phpAuthUser } from "../core/php-data-access";
import { AdClickTrackingApi, type AdInteractionType } from "./ad-click-tracking-api";
import { adClickTrackingForm } from "./ad-click-tracking-form";

export class AdClickTrackingHandler {
    public handleDocumentClick(event: MouseEvent): void {
        const link = adClickTrackingForm.getClosestTrackableLink(event.target);
        if (!(link instanceof HTMLAnchorElement)) {
            return;
        }

        const adSlot = adClickTrackingForm.getClosestTrackableAdSlot(link);
        if (!(adSlot instanceof HTMLElement)) {
            return;
        }

        const currentUserId = Number(phpAuthUser().user_id || 0);
        if (!Number.isInteger(currentUserId) || currentUserId <= 0) {
            return;
        }

        const adId = Number(adSlot.dataset.adId || 0);
        const adType = String(adSlot.dataset.adType || "")
            .trim()
            .toUpperCase();
        if (!Number.isInteger(adId) || adId <= 0 || adType === "") {
            return;
        }

        const interactionType: AdInteractionType =
            adType === "TOP_BANNER" || adType === "SECTION_BANNER" ? "banner_click" : "ad_click";
        void AdClickTrackingApi.trackClick(adId, interactionType);
    }
}
